import React from "react";
import SeoHead, {
  buildFaqJsonLd,
  buildJsonLdGraph,
  howToJsonLd,
  organizationJsonLd,
  softwareJsonLd,
  websiteJsonLd,
} from "../components/SeoHead";
import { FAQS, STEPS } from "../data/landingContent";
import Hero from "../components/landing/Hero";
import ProblemSolution from "../components/landing/ProblemSolution";
import ProductPreview from "../components/landing/ProductPreview";
import PatientJourney from "../components/landing/PatientJourney";
import Integrations from "../components/landing/Integrations";
import AgentOSLayer from "../components/landing/AgentOSLayer";
import ProductPillars from "../components/landing/ProductPillars";
import Modules from "../components/landing/Modules";
import WhyDifferent from "../components/landing/WhyDifferent";
import HowItWorks from "../components/landing/HowItWorks";
import SecurityTrust from "../components/landing/SecurityTrust";
import TestimonialsDaa from "../components/landing/TestimonialsDaa";
import FAQ from "../components/landing/FAQ";
import FinalCTA from "../components/landing/FinalCTA";
import SupportedByLogos from "../components/landing/SupportedByLogos";

export default function Home() {
  const jsonLd = buildJsonLdGraph(
    organizationJsonLd(),
    softwareJsonLd(),
    websiteJsonLd(),
    howToJsonLd(STEPS),
    buildFaqJsonLd(FAQS)
  );

  return (
    <>
      <SeoHead
        title="Deepaarogya AI — AI Hospital OS for Indian Clinics"
        description="Deepaarogya AI is hospital EMR software for India — OPD, IPD, pharmacy, billing, physio, Google Drive patient sync, WhatsApp e-Rx and reminders, and AI agents on one ABDM-ready record. Book a demo."
        path="/"
        jsonLd={jsonLd}
      />
      <Hero />
      <ProblemSolution />
      <WhyDifferent />
      <PatientJourney />
      <ProductPreview />
      <Integrations />
      <AgentOSLayer />
      <ProductPillars />
      <Modules />
      <HowItWorks />
      <SecurityTrust />
      <SupportedByLogos />
      <TestimonialsDaa />
      <FAQ />
      <FinalCTA />
    </>
  );
}
